import React from 'react'
import orbitLogo from '../../Assets/orbit_logo_transparent.png'
import './LoadingScreen.css'

export default function LoadingScreen() {
  return (
    <div className="auth-loading-root">
      <img src={orbitLogo} alt="Orbit Intel" className="auth-loading-logo" />
      <div className="auth-loading-spinner" />
    </div>
  )
}
